export default {
      id: "as-accessible-fitting-room-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-accessible-fitting-room",
      toString: function () {
        return this.url;
      }
    }